import globalWindow from '@shared/core/globals';

export const getDeviceResolution = () => {
  return Math.max(Math.min(Math.round(globalWindow.devicePixelRatio || 1), 3), 1);
};
